// composables/useApi.ts
import { type UseFetchOptions } from 'nuxt/app'
import defu from 'defu'

import { encrypt_bson } from '~/utils/secure_messaging'

import HybridCrypto from '~/utils/hybrid_crypto'

type OtkResponse = {
  success: boolean
  public_key: string
  uuid: string
}



export const useApi = () => {
  const config = useRuntimeConfig()
  // const token = import.meta.client ? localStorage.getItem('token') : null

  const cookie = useCookie('token')

  const base_url = config.public.api_url || 'https://cs-wl-api.netwood.site'

  // В режиме разработки используем моковый токен если реальный отсутствует
  const token = cookie.value || (process.dev ? 'demo-token' : null)


  const fetchWrapper = async <R>(endpoint: string, options: UseFetchOptions<any> = {}) => {

    // Базовые опции для всех запросов
    const defaults: UseFetchOptions<R> = {
      // baseURL: config.public.api_url || 'https://ptp-api.netwood.site',
      baseURL: base_url,
      // Добавляем обработку ошибок
      onResponseError: ({ response }) => {
        if (response.status === 401) {
          // Можно добавить логику для обновления токена или редирект на логин
          navigateTo('/?error=403')
        }
        if (response.status === 403) {
          // Можно добавить логику для редиректа на страницу 404
          navigateTo('/?error=403')
          // toast.add({
          //   color: 'red',
          //   description: 'Для доступа к этой странице необходимо авторизоваться',
          //   timeout: 5000
          // })
        }
      }
    }

    // Настраиваем заголовки в зависимости от окружения
    // if (import.meta.dev && import.meta.client && cookie.value) {
    //   // Для локальной разработки используем Authorization header
    //   defaults.headers = {
    //     ...options.headers,
    //     'Authorization': `Bearer ${cookie.value}`
    //   }
    // } 

    // Используем токен если он доступен
    if (token) {
      defaults.headers = {
        ...options.headers,
        'Authorization': `Bearer ${token}`
      }
    }
    
    // else {
    //   // Для production используем куки
    //   defaults.credentials = 'include'
    // }

    // Объединяем дефолтные опции с переданными
    const finalOptions: UseFetchOptions<R> = defu(options, defaults)

    return $fetch<R>(endpoint, finalOptions as any)
  }

  return {
    // GET запрос
    get: <T>(endpoint: string, data: any = {},  options: UseFetchOptions<T> = {}) => {
      return fetchWrapper<T>(endpoint, { ...options, method: 'GET', query: data })
    },

    // POST запрос
    post: <T>(endpoint: string, data: any = {}, options: UseFetchOptions<T> = {}) => {
      return fetchWrapper<T>(endpoint, {
        ...options,
        method: 'POST',
        body: data
      })
    },

    post_form: <T>(endpoint: string, form_data: any = {}, options: UseFetchOptions<T> = {}) => {
      return fetchWrapper<T>(endpoint, {
        ...options,
        method: 'POST',
        body: form_data
      })
    },

    post_secure: async <T>(endpoint: string, data: any = {}, options: UseFetchOptions<T> = {}) => {

      const otk_response = await fetchWrapper('/api/secure/otk', { ...options, method: 'POST' })

      // console.log('otk_response',otk_response)

      const body = {
        data: await encrypt_bson(otk_response.public_key, data),
        uuid: otk_response.uuid
      }

      // console.log('body',body)

      return fetchWrapper<T>(endpoint, {
        ...options,
        method: 'POST',
        body: body,
      })
    },

    post_hybrid_otk: async <T>(endpoint: string, data: any = {}, options: UseFetchOptions<T> = {}) => {

      const server_otk_response = await fetchWrapper<OtkResponse>('/api/secure/otk', { ...options, method: 'POST' })

      // console.log('server_otk_response',server_otk_response)

      const randomBytes = new Uint8Array(32)
			crypto.getRandomValues(randomBytes)
			const client_otk_decrypted = btoa(String.fromCharCode.apply(null, [...randomBytes]))

      const data_encrypted = await HybridCrypto.hybridEncrypt(
				atob(server_otk_response.public_key),
				JSON.stringify(data),
				client_otk_decrypted,
			)

      const body = {
        data: data_encrypted.encryptedData,
        client_otk: data_encrypted.encryptedPassword,
        uuid: server_otk_response.uuid
      }

      // console.log('body',body)

      return fetchWrapper<T>(endpoint, {
        ...options,
        method: 'POST',
        body: body,
      })
    },

    // PUT запрос
    put: <T>(endpoint: string, data: any, options: UseFetchOptions<T> = {}) => {
      return fetchWrapper<T>(endpoint, {
        ...options,
        method: 'PUT',
        body: data
      })
    },

    // DELETE запрос
    delete: <T>(endpoint: string, options: UseFetchOptions<T> = {}) => {
      return fetchWrapper<T>(endpoint, { ...options, method: 'DELETE' })
    },

    get_receipt_image_url: (file_name: string) => {
      return `${base_url}/api/client/fg/receipt_image/${file_name}`
    }
  }

  
}